module.exports = __webpack_public_path__ + "img/kotlin.56781a9f.png";